import React from "react";
import { getVendorToken } from "../../service/AuthService";
import { Navigate, Outlet } from "react-router-dom";


const VPrivateRoute = () => {
 const auth = getVendorToken();

  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  return auth ? <Outlet /> : <Navigate to="/vendor-signin" />;
};
 export default VPrivateRoute